
__webpack_require__.initializeExposesData = {
  moduleMap: {
  "./app": () => {
return Promise.all(/*  | __federation_expose_app */ [__webpack_require__.e("964"), __webpack_require__.e("573"), __webpack_require__.e("194")]).then(() => (() => (__webpack_require__(82472))));
},
"./constants": () => {
return Promise.all(/*  | __federation_expose_constants */ [__webpack_require__.e("964"), __webpack_require__.e("827")]).then(() => (() => (__webpack_require__(90812))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };